var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17962 25.6979V21.6209C9.17962 20.5802 10.0295 19.7365 11.0778 19.7365H14.9101C15.4135 19.7365 15.8963 19.935 16.2523 20.2884C16.6083 20.6418 16.8083 21.1211 16.8083 21.6209V25.6979C16.8051 26.1305 16.976 26.5466 17.2831 26.8537C17.5902 27.1607 18.008 27.3334 18.4438 27.3334H21.0584C22.2794 27.3365 23.4516 26.8572 24.3161 26.0012C25.1807 25.1451 25.6666 23.9827 25.6666 22.7705V11.1559C25.6666 10.1767 25.2293 9.24787 24.4727 8.61964L15.5786 1.56791C14.0315 0.331497 11.8147 0.371418 10.3138 1.66272L1.6226 8.61964C0.830239 9.22935 0.356655 10.1609 0.333252 11.1559V22.7587C0.333252 25.2852 2.39643 27.3334 4.94148 27.3334H7.49631C8.40155 27.3334 9.13725 26.6084 9.14381 25.7097L9.17962 25.6979Z",
    fill: "#3C4564"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.9e4bd6b0.svg";
export { ForwardRef as ReactComponent };